import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import { HubSpotCalendarPopupProps } from "./HubSpotCalendarPopup.types";
import { useBooleanState } from "../../hooks";
import { Helmet } from "react-helmet";
import { IconButton } from "../common";
import { CloseIcon } from "../../icons";

export const HubSpotCalendarPopup: React.FC<HubSpotCalendarPopupProps> = ({
  children,
  ...rest
}) => {
  const isPopupOpen = useBooleanState(false);

  return (
    <Box {...rest}>
      {isPopupOpen.state && (
        <>
          <Helmet>
            <script
              type="text/javascript"
              src="https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js"
            ></script>
          </Helmet>
          <Box
            pos={"fixed"}
            left={0}
            right={0}
            top={0}
            bottom={0}
            zIndex={"modal"}
          >
            <Box
              pos={"fixed"}
              left={0}
              right={0}
              top={0}
              bottom={0}
              zIndex={"overlay"}
              bg={"blackAlpha.500"}
              onClick={isPopupOpen.false}
            />

            <Flex
              alignItems={"center"}
              justifyContent={"center"}
              position={"fixed"}
              left={0}
              right={0}
              bottom={0}
              top={0}
              padding={{ base: 0, md: 8 }}
              zIndex={"modal"}
              onClick={isPopupOpen.false}
            >
              <Box pos={"absolute"} right={0} top={0} p={4}>
                <IconButton onClick={isPopupOpen.false} isGhost>
                  <CloseIcon color={"text.white"} boxSize={8} />
                </IconButton>
              </Box>
              <Box w={"100%"} maxW={"800px"}>
                <div
                  className="meetings-iframe-container"
                  data-src="https://meetings.hubspot.com/verivest/investor-assist?embed=true"
                ></div>
              </Box>
            </Flex>
          </Box>
        </>
      )}

      <Box onClick={isPopupOpen.true}>{children}</Box>
    </Box>
  );
};
